"use client";

import { useMediaQuery } from "@/hooks/use-media-query";

/**
 * Le pointeur principal est un doigt.
 *
 * `pointer` et non `any-pointer` : sur un portable tactile, le trackpad reste
 * le pointeur principal et l'écran n'est qu'un périphérique d'appoint. Viser
 * `any-pointer` y ferait basculer toute la mise en page vers le tactile alors
 * que l'utilisateur n'a pas quitté sa souris.
 */
export const COARSE_POINTER_QUERY = "(pointer: coarse)";

/**
 * Vrai quand le produit est manipulé au doigt.
 *
 * C'est le seul critère qui sépare une tablette d'un poste de bureau : un iPad
 * en paysage fait 1180 px de large et tombe donc dans `expanded`, au milieu de
 * la plage des portables. Une décision de mise en page indexée sur la largeur
 * raterait précisément l'appareil qu'on vise, qui est aussi la posture de
 * référence du produit (la tablette sur le pupitre). Le pendant côté rendu
 * existe déjà dans `lib/studio/view/components/piano-component.ts`, où le même
 * constat est écrit ; ce hook est ce qui manquait côté chrome React.
 *
 * Comme {@link useMediaQuery}, renvoie `false` au premier rendu (SSR et
 * première frame client) puis se corrige à l'effet de montage. À n'utiliser
 * que derrière une garde de montage, ou pour une décision qui ne se peint pas.
 * Un basculement visuel s'écrit en CSS avec la variante `pointer-coarse:`, qui
 * est juste dès le premier pixel ; c'est ce que fait déjà l'écran
 * {@link ../components/studio/handheld-notice}.
 */
export function useCoarsePointer(): boolean {
  return useMediaQuery(COARSE_POINTER_QUERY);
}
